<!--
 * @Descripttion: 注册页面组件 - 手机验证码注册
 * @Author: congz
 * @Date: 2020-06-11 10:01:19
 * @LastEditors: congz
 * @LastEditTime: 2020-08-18 19:58:16
--> 

<template>
  <div class="register">
    <div>
      <el-card class="box-card" shadow="hover">
        <div slot="header" class="clearfix">
          <span>Register</span>
        </div>
        <div class="register-tabs">
          <span
            class="tab-item"
            :class="{ active: registerMode === 'phone' }"
            @click="switchMode('phone')"
          >Phone</span>
          <span class="tab-divider">|</span>
          <span
            class="tab-item"
            :class="{ active: registerMode === 'email' }"
            @click="switchMode('email')"
          >Email</span>
        </div>

        <!-- Phone register -->
        <div class="item" v-if="registerMode === 'phone'">
          <el-form :model="form" status-icon :rules="rules" ref="form">
            <el-form-item prop="phone">
              <el-input v-model="form.phone" placeholder="Phone number"></el-input>
            </el-form-item>
            <el-form-item prop="code">
              <el-input v-model="form.code" placeholder="Verification code">
                <template slot="append">
                  <el-button
                    :disabled="smsCounting"
                    @click="sendOTP"
                    style="padding:10px 8px;font-size:12px;"
                  >{{ smsBtnText }}</el-button>
                </template>
              </el-input>
            </el-form-item>
          </el-form>
          <div style="margin-top:15px">
            <a href="javascript:;" class="btn-gradient desert block" @click="register('form')">Register</a>
          </div>
          <el-link type="primary" href="/#/login" style="float:right;margin-bottom:20px;">Already have an account? Log in directly></el-link>
        </div>

        <!-- Email register -->
        <div class="item" v-if="registerMode === 'email'">
          <el-form :model="emailForm" status-icon :rules="emailRules" ref="emailForm">
            <el-form-item prop="email">
              <el-input v-model="emailForm.email" placeholder="Email address"></el-input>
            </el-form-item>
            <el-form-item prop="code">
              <el-input v-model="emailForm.code" placeholder="Verification code">
                <template slot="append">
                  <el-button
                    :disabled="emailCounting"
                    @click="sendEmailOTP"
                    style="padding:10px 8px;font-size:12px;"
                  >{{ emailBtnText }}</el-button>
                </template>
              </el-input>
            </el-form-item>
          </el-form>
          <div style="margin-top:15px">
            <a href="javascript:;" class="btn-gradient desert block" @click="registerByEmail('emailForm')">Register</a>
          </div>
          <el-link type="primary" href="/#/login" style="float:right;margin-bottom:20px;">Already have an account? Log in directly></el-link>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import * as userAPI from '@/api/users'

export default {
  name: 'Register',
  data() {
    var validatePhone = function(rule, value, callback) {
      if (value === '') {
        callback(new Error('Please enter phone number'))
      } else if (!/^[0-9]{7,15}$/.test(value)) {
        callback(new Error('Please enter a valid phone number'))
      }
      callback()
    }
    var validateEmail = function(rule, value, callback) {
      if (value === '') {
        callback(new Error('Please enter email address'))
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
        callback(new Error('Please enter a valid email address'))
      }
      callback()
    }
    var validateCode = function(rule, value, callback) {
      if (value === '') {
        callback(new Error('Please enter verification code'))
      } else if (!/^[0-9]{6}$/.test(value)) {
        callback(new Error('Please enter a 6-digit verification code'))
      }
      callback()
    }
    return {
      registerMode: 'phone',
      form: {
        phone: '',
        code: ''
      },
      emailForm: {
        email: '',
        code: ''
      },
      rules: {
        phone: [{ validator: validatePhone, trigger: 'blur' }],
        code: [{ validator: validateCode, trigger: 'blur' }]
      },
      emailRules: {
        email: [{ validator: validateEmail, trigger: 'blur' }],
        code: [{ validator: validateCode, trigger: 'blur' }]
      },
      smsCounting: false,
      smsCountdown: 60,
      smsBtnText: 'Send OTP',
      emailCounting: false,
      emailCountdown: 60,
      emailBtnText: 'Send Code'
    }
  },
  methods: {
    ...mapActions(['setUser']),
    switchMode(mode) {
      this.registerMode = mode
    },
    handleRegisterSuccess(res) {
      if (res.status === 200) {
        var user = JSON.stringify(res.data.user)
        localStorage.setItem('user', user)
        localStorage.setItem('token', res.data.token)
        this.setUser(res.data.user)
        this.notifySucceed('Registered successfully')
        this.$router.push({ name: 'Home' })
      } else {
        this.notifyError('Registration failed', res.msg)
      }
    },
    register(formName) {
      var self = this
      this.$refs[formName].validate(function(valid) {
        if (!valid) { return }
        userAPI.smsLogin(self.form)
          .then(function(res) {
            self.handleRegisterSuccess(res)
          })
          .catch(function(error) {
            self.notifyError('Registration failed', error)
          })
      })
    },
    sendOTP() {
      var self = this
      var phoneVal = this.form.phone
      if (!phoneVal || !/^[0-9]{7,15}$/.test(phoneVal)) {
        this.notifyError('Invalid phone', 'Please enter a valid phone number')
        return
      }
      this.smsCounting = true
      this.smsBtnText = this.smsCountdown + 's'
      var timer = setInterval(function() {
        self.smsCountdown--
        self.smsBtnText = self.smsCountdown + 's'
        if (self.smsCountdown <= 0) {
          clearInterval(timer)
          self.smsCounting = false
          self.smsCountdown = 60
          self.smsBtnText = 'Send OTP'
        }
      }, 1000)

      userAPI.sendSMSCode(phoneVal)
        .then(function(res) {
          if (res.status === 200) {
            self.notifySucceed('Verification code sent')
          } else {
            self.notifyError('Failed to send', res.msg)
          }
        })
        .catch(function(error) {
          self.notifyError('Failed to send', error)
        })
    },
    sendEmailOTP() {
      var self = this
      var emailVal = this.emailForm.email
      if (!emailVal || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailVal)) {
        this.notifyError('Invalid email', 'Please enter a valid email address')
        return
      }
      this.emailCounting = true
      this.emailBtnText = this.emailCountdown + 's'
      var timer = setInterval(function() {
        self.emailCountdown--
        self.emailBtnText = self.emailCountdown + 's'
        if (self.emailCountdown <= 0) {
          clearInterval(timer)
          self.emailCounting = false
          self.emailCountdown = 60
          self.emailBtnText = 'Send Code'
        }
      }, 1000)

      userAPI.sendEmailCode(emailVal)
        .then(function(res) {
          if (res.status === 200) {
            self.notifySucceed('Verification code sent to your email')
          } else {
            self.notifyError('Failed to send', res.msg)
          }
        })
        .catch(function(error) {
          self.notifyError('Failed to send', error)
        })
    },
    registerByEmail(formName) {
      var self = this
      this.$refs[formName].validate(function(valid) {
        if (!valid) { return }
        userAPI.emailLogin(self.emailForm)
          .then(function(res) {
            self.handleRegisterSuccess(res)
          })
          .catch(function(error) {
            self.notifyError('Registration failed', error)
          })
      })
    }
  }
}
</script>

<style scoped>
@import '../assets/css/button.css';
.text {
  font-size: 14px;
}
.item {
  margin: 0 auto;
  width: 300px;
}
.clearfix {
  font-size: 20px;
}
.register-tabs {
  margin-bottom: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
}
.tab-item {
  cursor: pointer;
  font-size: 15px;
  color: #999;
  transition: color 0.2s;
}
.tab-item.active {
  color: #B9365B;
  font-weight: 600;
}
.tab-divider {
  color: #ccc;
}
.box-card {
  margin: 0 auto;
  text-align: center;
  width: 400px;
  margin-top: 100px;
  margin-bottom: 200px;
  border-radius: 10px;
}
</style>
